import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'

export const CityRoutes = [
  {
    path: '/cities',
    name: 'ListCities',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'city:list'
    }
  },
  {
    path: '/city',
    name: 'CreateCity',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'city:create'
    }
  },
  {
    path: '/city/:id',
    name: 'UpdateCity',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'city:update'
    }
  }
]
